import Config from '../config/constants';
import axios from 'axios';

/** 제로살롱몰 상품 목록을 조회합니다. */
export const apiGetZeroSalonItemList = async (
  params: { page?: number; limit?: number },
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/zerosalon-item/list`;
  try {
    const response = await axios.get(url, {
      headers: { access_token: accessToken },
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching zerosalon items:', error);
    throw error;
  }
};

/** 제로살롱몰 상품 이미지를 S3에 업로드합니다. */
export const apiUploadZeroSalonItemImage = async (
  file: File,
  accessToken: string,
): Promise<string> => {
  const url = `${Config.API_HOST}/api/admin/zerosalon-item/upload`;
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await axios.post(url, formData, {
      headers: {
        access_token: accessToken,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading zerosalon item image:', error);
    throw error;
  }
};

/** 새 제로살롱몰 상품을 생성합니다. */
export const apiCreateZeroSalonItem = async (
  body: { imageUrl: string; name: string; linkUrl?: string; isActive?: boolean; sortOrder?: number },
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/zerosalon-item`;
  try {
    const response = await axios.post(url, body, {
      headers: { access_token: accessToken },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating zerosalon item:', error);
    throw error;
  }
};

/** 제로살롱몰 상품 정보를 수정합니다. */
export const apiUpdateZeroSalonItem = async (
  id: number,
  body: { imageUrl?: string; name?: string; linkUrl?: string; isActive?: boolean; sortOrder?: number },
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/zerosalon-item/${id}`;
  try {
    const response = await axios.patch(url, body, {
      headers: { access_token: accessToken },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating zerosalon item:', error);
    throw error;
  }
};

/** 제로살롱몰 상품을 삭제합니다. */
export const apiDeleteZeroSalonItem = async (
  id: number,
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/zerosalon-item/${id}`;
  try {
    const response = await axios.delete(url, {
      headers: { access_token: accessToken },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting zerosalon item:', error);
    throw error;
  }
};
